import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ngxExcelCurrency'
})

export class NgxExcelCurrencyPipe implements PipeTransform {

  /**
   * æ ¼å¼åæ¾ç¤ºéé¢
   * @param value å­ç¬¦åéé¢
   * @param places å°æ°ä½æ°
   * @param decimal å°æ°ç¹ç¬¦å·
   * @param thousand åä½åéç¬¦
   * @param symbol è´§å¸ç¬¦å·
   * @param abs æ¯å¦åç»å¯¹å¼
   */
  transform(value: string, places?: number, decimal?: string, thousand?: string, symbol?: string, abs?: boolean): string {
    if (abs) {
      value = Math.abs(parseFloat(value)).toString();
    }
    places = !isNaN(places = Math.abs(places)) ? places : 2;
    symbol = symbol || '';
    thousand = thousand || '';
    decimal = decimal || '.';
    const number = Math.abs(/^(-)?\d+(\.\d+)?$/.test(value) ? parseFloat(value) : 0).toFixed(places);
    const negative = parseInt(value, 10) < 0 ? '-' : '';
    const i = `${parseInt(number, 10)}`;
    let j = i.length;
    j = j > 3 ? j % 3 : 0;
    return symbol + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
      (places ? decimal + Math.abs(parseFloat(number) - parseInt(i, 10)).toFixed(places).slice(2) : '');
  }
}
